<template>
    <CHeader
      data-aos-easing="linear"
      data-aos-duration="1500"
      id="el"
      class="navbars"
    >
      <CHeaderBrand class="mx-auto" href="https://www.pickiddo.com">
        <img src="../assets/img/icon/logoiBlue.png" height="48px" class="m-2" />
      </CHeaderBrand>
  
      <CDropdown color="light" class="m-2 d-sm-flex d-lg-none" :caret="false">
        <template #toggler-content>
          <CIcon name="cil-justify-center" />
        </template>
        <CDropdownItem :to="'ExamBank?startId=' + $route.query.startId">HOMEPAGE</CDropdownItem>
        <!-- <CDropdownItem href="../ExamLeaderboard"
          >LEADERBOARD</CDropdownItem
        > -->
        <!-- <CDropdownItem to="/Sharing"
            >SHARING</CDropdownItem
          > -->
      </CDropdown>
  
      <CHeaderNav class="d-md-down-none mr-auto">
        <CHeaderNavItem class="px-3"> </CHeaderNavItem>
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
              font-family: 'Montserrat', sans-serif;
              font-weight: bold;
              font-size: 15px;
            "
           :to="'ExamBank?startId=' + $route.query.startId"
          >

            <img style="max-height: 50px" src="../assets/img/icon/homewhite.png" />
            <!-- Now "Start New" is inside a separate <div> and will be on a new line -->
          </CHeaderNavLink>
          
        </CHeaderNavItem>
        <!-- <CHeaderNavItem class="px-3">
            <CHeaderNavLink
              style="
                font-family: 'Montserrat', sans-serif;
                font-weight: bold;
                font-size: 15px;
                
              "
              href="../ExamLeaderboard"
            >
              Leaderboard
            </CHeaderNavLink>
          </CHeaderNavItem> -->
        <!-- <CHeaderNavItem class="px-3">
            <CHeaderNavLink
              style="
                font-family: 'Montserrat', sans-serif;
                font-weight: bold;
                font-size: 15px;
              "
              to="ExamSharing"
            >
              Sharing
            </CHeaderNavLink>
          </CHeaderNavItem> -->
      </CHeaderNav>
    </CHeader>
  </template>
        
      <script>
  import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
  
  export default {
    name: "TheHeader",
    components: {
      TheHeaderDropdownAccnt,
    },
    mounted() {
      if (localStorage.getItem("reloaded")) {
        // The page was just reloaded. Clear the value from local storage
        // so that it will reload the next time this page is visited.
        localStorage.removeItem("reloaded");
      } else {
        // Set a flag so that we know not to reload the page twice.
        localStorage.setItem("reloaded", "1");
        location.reload();
      }
      // this.googleTranslateElementInit();
    },
    methods: {
      // googleTranslateElementInit() {
      //   window.google.translate.TranslateElement(
      //     {
      //       pageLanguage: "en",
      //       includedLanguages: "en,ms",
      //       layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
      //       autoDisplay: false,
      //     },
      //     "google_translate_element"
      //   );
      // },
    },
  };
  </script>
   
    <style scoped>
  .dropdown-item:hover {
    color: #4f5d73;
    background: #ddd;
  }
  .c-header {
    background: transparent;
    border-bottom: 1px solid transparent;
  }
  </style>
    
    
    